import { getEnabledCustomerExperiences } from '../shopConfig/configHelper';
import { Feature } from '../util/featureFlags';
import { useShopConfig } from './shopConfig';
import { useFeatureFlags } from './useFeatureFlags';
import { CustomerExperience } from '../types/shopConfig/shopConfigV2';
import { BuilderSections } from '../util/builder';
import { useWeglot } from './useWeglot';

export const useShouldShowMainSiteBanner = (): boolean => {
  const isMainSiteBannerFeatureFlagEnabled = useFeatureFlags(Feature.MainSiteBanner);
  const { enabledCustomerExperiences, builderConfig } = useShopConfig();
  const { isTradeInOnly: isBrandTradeInOnly } = getEnabledCustomerExperiences(
    enabledCustomerExperiences as CustomerExperience[] | undefined
  );

  const isWeGlotEnabled = !!useWeglot().weglot;
  const isBuilderDesktopTopbarConfigured = builderConfig?.sections?.[BuilderSections.TopbarContent];

  return (
    isMainSiteBannerFeatureFlagEnabled &&
    !isBrandTradeInOnly &&
    // Enable for builder desktop topbars only when Weglot is enabled
    !(isBuilderDesktopTopbarConfigured && !isWeGlotEnabled)
  );
};
